/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { ChangeDetectionStrategy, Component, EventEmitter, OnInit, Output } from '@angular/core';
import { DataService } from '../../services/data.service';
import { UtilsService } from '../../services/utils.service';
import { ChangeDetectorRef } from '@angular/core';
import { UserService } from '../../services/user.service';

// Define an interface for FAQ structure
interface Faq {
  
  question: string;
  type: string;


}

@Component({
  selector: 'app-faqs',
  templateUrl: './faqs.component.html',
  styleUrls: ['./faqs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FaqsComponent implements OnInit {


  @Output() submitFaq: EventEmitter<{ success: boolean, query: string }> = new EventEmitter();


  faqs: Faq[] = [
  ];
  faqsLoaded: any;
  trainerMode:any=false

  constructor(private dataService: DataService, public us: UtilsService, private cdr: ChangeDetectorRef,private userService:UserService) { }

  ngOnInit() {
    this.trainerMode=this.userService.getTrainerMode();
    this.getFaqs();

  }

  chunk(array: any[], size: number): any[] {
    const result = [];
    for (let i = 0; i < array.length; i += size) {
      result.push(array.slice(i, i + size));
    }
    return result;
  }
  onCardClick(query: string) {
    this.submitFaq.emit({ success: true, query });
  }
  getFaqs() {
    this.us.dataLoaded = false;
    // this.cdr.detectChanges();
    this.dataService.getFaqs().subscribe((res) => {
      if(res.data.length === 0){
        this.faqsLoaded = false;
        this.cdr.detectChanges();
      }
      else{
      this.faqs = res.data;
      this.us.suggestedFaqs=this.faqs;
      this.faqsLoaded = true;
      }
      this.us.dataLoaded = true;
      this.cdr.detectChanges();
    },
      (err) => {
        this.us.dataLoaded = true; 
        this.faqsLoaded = false;
        this.cdr.detectChanges();
      }
    );
  }

  
}
